import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Gem, Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (e2) {
      setErr(apiErr(e2));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-background">
      <div className="w-full max-w-md" data-testid="forgot-password-page">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <Gem className="h-7 w-7 text-primary" strokeWidth={1.5} />
          <span className="font-display font-extrabold text-xl">Jewel<span className="text-primary">tix</span></span>
        </Link>
        {sent ? (
          <div className="border border-emerald-300 bg-emerald-50 text-emerald-900 rounded-md p-6" data-testid="forgot-sent">
            <MailCheck className="h-6 w-6 mb-2" />
            <h1 className="font-display font-bold text-xl">Check your inbox</h1>
            <p className="text-sm mt-2">
              If <b>{email}</b> is registered with us, a reset link is on its way. It works once and expires in 60 minutes.
            </p>
            <Link to="/login" className="inline-block mt-4 text-sm font-semibold underline" data-testid="forgot-back-login">Back to log in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="border border-border rounded-md bg-card p-6">
            <h1 className="font-display font-bold text-2xl">Forgot your password?</h1>
            <p className="text-sm text-muted-foreground mt-1">
              Enter the email you signed up with and we'll send you a link to set a new password.
            </p>
            <label className="block mt-5">
              <span className="text-sm font-medium">Email</span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-email"
                className="mt-1 w-full border border-border rounded-md p-2.5 text-base bg-background focus:outline-none focus:border-primary"
              />
            </label>
            {err && <p className="text-sm text-destructive mt-3" data-testid="forgot-error">{err}</p>}
            <button
              disabled={busy}
              data-testid="forgot-submit"
              className="mt-5 w-full flex items-center justify-center gap-2 bg-primary text-primary-foreground rounded-md py-2.5 font-semibold hover:bg-primary/90 disabled:opacity-50"
            >
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Send reset link
            </button>
            <p className="text-sm text-muted-foreground mt-5 text-center">
              Remembered it? <Link to="/login" className="text-primary font-medium">Log in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
